//#region IMPORT
import React, { useState, useRef } from 'react';
import SAT_BASIC_06 from './SAT_BASIC_06';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { Loading } from '../../../../Components/MUIs';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import { useSave1, useSearch1 } from './SAT_BASIC_06_QUERY';
import { SAT_BASIC_06_Schema } from './SAT_BASIC_06_Schema';
import { useSave } from '../../../../hooks/useSaveN';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'SafetyHealthTraining';

function SAT_BASIC_06F(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  //로그 관련

  // 교육자료 등록 그리드
  const gridRef1 = useRef(); // 교육현황 그리드
  const [rowData1, setRowData1] = useState([]); // 교육자료 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 교육자료 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 교육자료 그리드 변경 시 데이터
  const selectedRowNosRef = useRef(new Set());
  const currentRowIndexRef = useRef(null);

  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.chaebun,
    getKeyFromResult: (result) => result.chaebun,
  });
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });
  const { runAsync: Save1Async } = useSave1();
  //#region 저장
  // 저장 로직
  const ResetLogicAll = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
  };
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '변경 사항',
    schema: SAT_BASIC_06_Schema,
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    requestSave: (rows) => Save1Async(rows),
    reset: ResetLogicAll,
    refresh: Search1,
    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });

  //#endregion

  //#region 나머지 함수
  //인쇄 함수
  const PrintLogic1 = async () => {
    setLoading(true);
    dispatch(showLoading());

    try {
      // HeaderData 설정
      const headerData = {
        YEAR: searchInfo.year,
      };

      // TableData 매핑 (레포트 양식에 맞게)
      const tableData = rowData1
        .filter((row) => !row.deleteYn) // 삭제된 행 제외
        .map((row, index) => {
          // 진행율 계산 (이수자 / 교육대상자 * 100)
          const targetCount = Number(row.sheTargetCount) || 0;
          const completerCount = Number(row.sheGraduate) || 0;
          let progressRate = 0;
          if (targetCount > 0 && completerCount > 0) {
            progressRate = (completerCount / targetCount) * 100;
          }
          const progressRateFormatted = Math.round(progressRate * 100) / 100; // 소수점 2자리

          return {
            NO: index + 1,
            SHE_NM: row.sheNm || '', // 교육명(노입력)
            SHE_PERIOD: row.shePeriod || '', // 기간(텍스트)
            SHE_TARGET_COUNT: row.sheTargetCount || 0, // 교육대상자 (인원수)
            SHE_GRADUATE: row.sheGraduate || 0, // 이수자 (인원수)(숫자)
            GRADUATE_RATE: progressRateFormatted, // 진행율(%) (자동계산)
          };
        });

      const printData = {
        FileName: 'TRA_BASIC_06',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
      dispatch(closeLoading());
    }
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    // onSelectionChanged에서 처리하므로 여기서는 currentRowIndexRef만 업데이트
    // setSelectedRowData1은 onSelectionChanged에서 처리됨
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  //#endregion

  return (
    <div className="wrap">
      <SAT_BASIC_06
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        showSnackbar={showSnackbar}
        dispatch={dispatch}
        filterClick6={props.filterClick6}
        setFilterClick6={props.setFilterClick6}
        searchClick6={props.searchClick6}
        setSearchClick6={props.setSearchClick6}
        addClick6={props.addClick6}
        setAddClick6={props.setAddClick6}
        saveClick6={props.saveClick6}
        setSaveClick6={props.setSaveClick6}
        deleteClick6={props.deleteClick6}
        setDeleteClick6={props.setDeleteClick6}
        printClick6={props.printClick6}
        setPrintClick6={props.setPrintClick6}
        // 함수
        validateSelection={props.validateSelection}
        ResetLogicAll={ResetLogicAll}
        SearchLogic1={Search1}
        SaveLogic1={Save1}
        PrintLogic1={PrintLogic1}
        // GridCheckBox 관련 props
        gridRef={gridRef1}
        selectedRowNosRef={selectedRowNosRef}
        handleRowSelection={handleRowSelection}
        NewYnErrorMsg={NewYnErrorMsg}
      />
      <Loading open={loading} />
    </div>
  );
}

export default SAT_BASIC_06F;
